import { Header } from "@/presentation/components";
import { Form } from "@/presentation/components/Forms/Form/Form";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { useAuthContext } from "@/presentation/context";
import { useSimple } from "@/presentation/hooks/useSimple";
import { useUbicacion } from "@/presentation/hooks/UseUbicacion";
import { routes } from "@/presentation/router";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function NuevaUbicacion() {




  const navigate = useNavigate();
  const { user, logout } = useAuthContext();
  const { data: grupos } = useSimple(
    'luc_ubicaciones_grupo'
  );
  const grupoOptions = grupos.map(
    (grupo) => ({
      value: grupo.id,
      label: grupo.nombre,
    })
  );


  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setIsDrawerOpen(false);
    navigate(routes.login, { replace: true });
  };
  const { id } = useParams();
  const editing = Boolean(id) && id !== '0';
  console.log(editing)

  const {
    data: ubicacion,
    reload: loadById,
    create,
    update,
  } = useUbicacion();

  const initialValues = useMemo(() => {
    if (!ubicacion) return undefined;

    return {
      nombre: ubicacion.nombre,
      grupo: ubicacion.grupo_id,
      cp: ubicacion.cp,
      direccion: ubicacion.direccion,
      barrio: ubicacion.barrio,
      provincia: ubicacion.provincia,
      observaciones: ubicacion.observaciones,
    };
  }, [ubicacion]);

  useEffect(() => {
    if (editing && id) {
      loadById(Number(id));
    }
  }, [editing, id, loadById]);
  console.log(ubicacion);

  const handleSubmitValues = async (
    values: Record<string, unknown>
  ) => {
    const nuevaUbicacion = {
      nombre: String(values.nombre),
      grupo: String(values.grupo ?? ""),
      direccion: String(values.direccion ?? ""),
      barrio: String(values.barrio ?? ""),
      provincia: String(values.provincia ?? ""),
      cp: Number(values.cp ?? 0),
      usuario: String(user?.id),
      fecha: new Date().toISOString(),
      observaciones: String(values.observaciones ?? ""),
      grupo_id:0
    };
    console.log(ubicacion)

    const ubicacionGuardada = editing && ubicacion
      ? await update(id!, nuevaUbicacion)
      : await create(nuevaUbicacion);

    navigate(`/ubicacion/${ubicacionGuardada.id}`, { replace: true });
  };






  return (
    <div>
      <Header title={'Nueva Ubicación'} onMenuClick={handleOpenDrawer} />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={handleCloseDrawer}
        onLogout={handleLogout}
      />

      <main style={{ padding: '24px' }}>
        <Form
          fields={[
            {
              name: 'grupo',
              label: 'Grupo',
              type: 'select',
              options: grupoOptions,
            },
            {
              name: 'cp',
              label: 'Categoría',
              type: 'select',
              options: [
                {
                  value: 1,
                  label: 'Stock'
                },
                {
                  value: 2,
                  label: 'CEL'
                },
                {
                  value: 3,
                  label: 'Taller'
                },
                {
                  value: 4,
                  label: 'Prestador'
                },
                {
                  value: 5,
                  label: 'CEL (PARTICULARES)'
                },
                {
                  value: 6,
                  label: 'CRI'
                },
                {
                  value: 7,
                  label: 'CGP'
                },
                {
                  value: 8,
                  label: 'CEL IDX'
                }
              ]
            },

            {
              name: 'nombre',
              label: 'Nombre',
              type: 'text',
            },
            {
              name: 'direccion',
              label: 'Dirección',
              type: 'text',
            },
            {
              name: 'barrio',
              label: 'Barrio',
              type: 'text',
            },
            {
              name: 'provincia',
              label: 'Provincia',
              type: 'text',
            },
            {
              name: 'observaciones',
              label: 'Observaciones',
              type: 'textarea',
              optional: true
            }

          ]}


          initialValues={initialValues}
          submitLabel={
            editing
              ? 'Guardar cambios'
              : 'Crear Ubicación'
          }
          onSubmit={handleSubmitValues}

        />


      </main>


    </div>
  );
}
